import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

import Localization from "../../localization";
import Button from "../../components/button";
import { recover } from "../../redux/actions/auth";
import IconClose from "../../components/icons/close";
import Tab from "./Tab";

class RecoverForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            success: null,
            error: null,
        };

        this._handleSubmit = this._handleSubmit.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (!this.props.isRecovering && prevProps.isRecovering) {
            if (this.props.error) {
                this.setState({
                    error: Localization[this.props.locale].recover.error,
                    success: null,
                });
            } else {
                this.setState({
                    error: null,
                    success: Localization[this.props.locale].recover.success,
                });
            }
        }
    }

    _handleSubmit(values) {
        this.props.recover(values.email);
    }

    _renderHeader() {
        const { pathname, locale, onTabPress, onClosePress } = this.props;

        return (
            <div className="flex items-center mb-40 xl:mb-60">
                <Tab
                    title={Localization[locale].recover.register}
                    url={"register"}
                    current={pathname}
                    onClick={onTabPress}
                />
                <Tab
                    title={Localization[locale].recover.login}
                    url={"login"}
                    current={pathname}
                    onClick={onTabPress}
                />
                <div className="flex-1" />
                <Button
                    icon={
                        <IconClose className="w-25 h-25 z-10 transition hover-hover:group-hover:text-white text-blue" />
                    }
                    onClick={onClosePress}
                    style={"w-50 xl:w-70"}
                />
            </div>
        );
    }

    _renderStep() {
        const { locale, isRecovering } = this.props;

        let recoverSchema = Yup.object().shape({
            email: Yup.string()
                .required(Localization[locale].validation.required)
                .email(Localization[locale].validation.email),
        });

        let initialValues = {
            email: "",
        };

        return (
            <Formik
                initialValues={initialValues}
                validationSchema={recoverSchema}
                onSubmit={this._handleSubmit}
            >
                {({ handleSubmit, values }) => (
                    <form onSubmit={handleSubmit}>
                        <p className="font-bold text-20 xl:text-30 text-blue mb-26 xl:mb-60">
                            {Localization[locale].recover.intro}
                        </p>
                        <div>
                            <Field
                                type="email"
                                name="email"
                                className="transition px-0 placeholder-black placeholder-opacity-20 bg-grey text-blue text-17 xl:text-23 font-bold border-0 border-b border-black border-opacity-20 focus:ring-0 focus:border-0 focus:border-b focus:shadow-none focus:border-blue block w-full"
                                placeholder={
                                    Localization[locale].login.email_placeholder
                                }
                            />
                            <p className="text-red text-12 mt-6">
                                <ErrorMessage name="email" />
                            </p>
                        </div>
                        <div className="flex flex-col xl:flex-row xl:items-center mt-26">
                            <div
                                onClick={() => {
                                    this.props.onBackPress("login");
                                }}
                                className="font-bold text-17 text-blue cursor-pointer"
                            >
                                {Localization[locale].recover.back}
                            </div>
                            <div className="flex-1" />
                            <Button
                                text={Localization[locale].recover.submit}
                                textStyle={
                                    "font-bold text-17 z-10 transition hover-hover:group-hover:text-white text-blue"
                                }
                                backgroundColor={"bg-grey"}
                                submit
                                style={"mt-26 xl:mt-0"}
								wrapperStyle="px-20"
                                isLoading={isRecovering}
                            />
                        </div>
                        {this.state.error && (
                            <p className="text-12 text-red mt-6 text-right">
                                {this.state.error}
                            </p>
                        )}
                        {this.state.success && (
                            <p className="text-12 mt-6 text-right">
                                {this.state.success}
                            </p>
                        )}
                    </form>
                )}
            </Formik>
        );
    }

    render() {
        const { isVisible, onClosePress } = this.props;

        let className =
            "fixed bottom-0 top-0 left-0 flex justify-end right-0 transition duration-700 ease-in-out transform z-20";

        if (!isVisible) {
            className += " " + "translate-x-full";
        }

        return (
            <div className={className}>
                <div onClick={onClosePress} className="xl:w-1/2" />
                <div className="flex flex-col w-full xl:w-1/2 px-16 xl:px-50 pt-30 xl:pt-40 pb-30 xl:pb-40 bg-grey">
                    {this._renderHeader()}
                    <div className="flex-1 overflow-y-auto">
                        {this._renderStep()}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    isRecovering: state.me.isRecovering,
    error: state.me.error,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            recover,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(RecoverForm);
